var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.67238 15.8615C1.24311 15.8615 0.880143 15.7132 0.583476 15.4165C0.286793 15.1199 0.138451 14.7569 0.138451 14.3276V1.67238C0.138451 1.24311 0.286793 0.880141 0.583476 0.583475C0.880143 0.286791 1.24311 0.138451 1.67238 0.138451H14.3276C14.7569 0.138451 15.1199 0.286791 15.4165 0.583475C15.7132 0.880141 15.8615 1.24311 15.8615 1.67238V14.3276C15.8615 14.7569 15.7132 15.1199 15.4165 15.4165C15.1199 15.7132 14.7569 15.8615 14.3276 15.8615H1.67238ZM1.67693 14.9385H5.075V10.925H1.06155V14.3231C1.06155 14.5026 1.11924 14.65 1.23463 14.7654C1.35001 14.8808 1.49744 14.9385 1.67693 14.9385ZM5.99808 14.9385H10.0019V10.925H5.99808V14.9385ZM10.925 14.9385H14.3231C14.5026 14.9385 14.65 14.8808 14.7654 14.7654C14.8808 14.65 14.9385 14.5026 14.9385 14.3231V10.925H10.925V14.9385ZM1.06155 10.0019H5.075V5.99807H1.06155V10.0019ZM5.99808 10.0019H10.0019V5.99807H5.99808V10.0019ZM10.925 10.0019H14.9385V5.99807H10.925V10.0019ZM1.06155 5.075H5.075V1.06155H1.67693C1.49744 1.06155 1.35001 1.11924 1.23463 1.23463C1.11924 1.35001 1.06155 1.49744 1.06155 1.67693V5.075ZM5.99808 5.075H10.0019V1.06155H5.99808V5.075ZM10.925 5.075H14.9385V1.67693C14.9385 1.49744 14.8808 1.35001 14.7654 1.23463C14.65 1.11924 14.5026 1.06155 14.3231 1.06155H10.925V5.075Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.afdf6d0c42a3ee5dc14dd0b205e3ce8e.svg";
export { ForwardRef as ReactComponent };